import React from 'react';
import PropTypes from 'prop-types';
import {
  Icon,
} from 'semantic-ui-react';

import styled from 'styled-components';

import {
  Segment as SegmentLayoutComponent,
  Text as TextLayoutComponent, Loader as LoaderLayoutComponent,
} from '@playbookux/playbook-web-core';

const hexToRGB = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${ r }, ${ g }, ${ b }, ${ alpha })`;
  }
  return `rgb(${ r }, ${ g }, ${ b })`;
};

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  max-width: 400px;
  width: auto;
`;

const Segment = styled(SegmentLayoutComponent)`
`;

const Logo = styled.img`
  margin-bottom: 45px;
  margin-top: 75px;
  max-width: 200px;
`;

const SignContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

const Title = styled(TextLayoutComponent.Title)`
  margin-bottom: 20px;
`;

const Text = styled(TextLayoutComponent)`
  margin-top: 10px;
  margin-bottom: 20px;
  text-align: center;
`;

const HaveAccount = styled(TextLayoutComponent)`
  margin-top: 30px;
`;

const Muted = styled(TextLayoutComponent.Muted)`
  margin-top: 30px;
`;

const SocialIcon = styled(Icon).attrs(({ name = 'linkedin' }) => ({
  name,
  size: 'large',
}))``;

const SocialButtonContainer = styled.div.attrs(({ provider }) => ({
  'data-oauth-command': `${provider}.call`,
}))`
  width: 300px;
  height: 40px;
  display: flex;
  flex-direction: row;
  background: ${({ bg }) => hexToRGB(bg, 0.8) || '#2a7bb6'};
  font-weight: 500;
  margin: 0px;
  padding: 0px 5px;
  border-radius: 3px;
  color: #fff;
  margin-bottom: 5px;
  cursor: pointer;

  &:hover {
    background: ${({ bg }) => hexToRGB(bg) || '#2a7bb6'};
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25)
  }
`;
const SocialButtonIcon = styled.div`
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
`;
const SociaButtonTitle = styled.span`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LinkedinButtonContainer = styled.div`
  width: 300px;
  height: 40px;
  display: flex;
  flex-direction: row;
  background: ${({ bg }) => hexToRGB(bg, 0.8) || '#2a7bb6'};
  font-weight: 500;
  margin: 0px;
  padding: 0px 5px;
  border-radius: 3px;
  color: #fff;
  margin-bottom: 5px;
  cursor: pointer;

  &:hover {
    background: ${({ bg }) => hexToRGB(bg) || '#2a7bb6'};
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25)
  }
`;

export const LinkedinButton = ({ href }) => {
  const { bg, icon, name } = { bg: '#2a7bb6', icon: 'linkedin', name: 'LinkedIn' };

  const handleClick = () => {
    window.location = href;
  };

  return (
    <LinkedinButtonContainer bg={bg} onClick={handleClick} href={href}>
      <SocialButtonIcon>
        <SocialIcon name={icon} />
      </SocialButtonIcon>
      <SociaButtonTitle>
        Sign Up with
        {' '}
        {name}
      </SociaButtonTitle>
    </LinkedinButtonContainer>
  );
};

export const SocialButton = ({ variant = 'linkedin', href, provider }) => {
  const variants = {
    google: { bg: '#dd4b39', icon: 'google', name: 'Google' },
    linkedin: { bg: '#2a7bb6', icon: 'linkedin', name: 'LinkedIn' },
    facebook: { bg: '#3b5998', icon: 'facebook', name: 'Facebook' },
  };

  const { bg, icon, name } = variants[variant];

  const handleClick = () => {
    if (href) {
      window.location = href;
    } else {
      switch (variant) {
        case 'facebook': {
          const [facebookBtn] = document.querySelectorAll('[data-oauth-command="fbidentity.call"]');
          if (facebookBtn) facebookBtn.click();
          break;
        }
        case 'google': {
          const [googleBtn] = document.querySelectorAll('[data-oauth-command="googleidentity.call"]');
          if (googleBtn) googleBtn.click();
          break;
        }
        default:
          console.log('Unknown OAuth variant');
      }
    }
  };

  return (
    <SocialButtonContainer bg={bg} onClick={handleClick} provider={provider}>
      <SocialButtonIcon>
        <SocialIcon name={icon} />
      </SocialButtonIcon>
      <SociaButtonTitle>
        Sign Up with
        {' '}
        {name}
      </SociaButtonTitle>
    </SocialButtonContainer>
  );
};

LinkedinButton.propTypes = {
  href: PropTypes.string,
};

LinkedinButton.defaultProps = {
  href: '',
};

SocialButton.propTypes = {
  variant: PropTypes.string.isRequired,
  href: PropTypes.string,
  provider: PropTypes.string.isRequired,
};
SocialButton.defaultProps = {
  href: '',
};

const Loader = styled(LoaderLayoutComponent)`
  margin-top: 45px;
`;

export {
  Container,
  HaveAccount,
  Loader,
  Logo,
  Muted,
  Segment,
  SignContainer,
  Text,
  Title,
};
